module.exports = "/_next/static/images/e5826b1ee1487ada01eba208432cb815-soriana-icon.svg.webp";